<template>
  <div class='spnod-messages border rounded d-flex flex-column h-100 w-100 p-2 position-absolute'>
    <h4 class="h4 text-center mb-4">Message Details</h4>
    <div v-if="message && message.client" class="w-100 h-100 d-flex flex-column p-0 overflow-auto">
      <div class="spnod-admin__account--section mx-auto">
        <img v-if="getMyInfo.hasRoles && clientAvatar" :src="clientAvatar" class="rounded" width="200px" height="200px" />
        <img v-else-if="nutritionistAvatar" :src="nutritionistAvatar" class="rounded" width="200px" height="200px" />
      </div>
      <div class="spnod-admin__account--section">
        <h5 class="spnod-admin__account--header">Client</h5>
        <b-row class="spnod-admin__account--row">
          <b-col><span class="text-muted">Name: </span>{{ message.client.name }}</b-col>
        </b-row>
        <b-row class="spnod-admin__account--row">
          <b-col>
          <span
            class="text-primary cursor-pointer"
            @click="redirectToUserAccount">Link to Account</span>
          </b-col>
        </b-row>
      </div>
      <div class="spnod-admin__account--section">
        <h5 class="spnod-admin__account--header">Nutritionist</h5>
        <b-row class="spnod-admin__account--row">
          <b-col><span class="text-muted">Name: </span>{{ message.client.nutritionist ? message.client.nutritionist.name : '' }}</b-col>
        </b-row>
      </div>
      <div class="spnod-admin__account--section">
        <h5 class="spnod-admin__account--header">Additional Participants</h5>
        <ul>
          <li class="spnod-admin__form--list" v-for="participant in participants">
            <span class="text-muted">Name: </span>{{ participant.name }}
          </li>
        </ul>
      </div>
      <div v-if="getMyInfo.hasRoles" class="spnod-admin__account--section">
        <h5 class="spnod-admin__account--header">Biometrics</h5>
        <ul v-if="biometrics">
          <li class="spnod-admin__form--list pb-2" v-for="question in biometrics">
            <b-row class="mx-0">{{ question.question }}</b-row>
            <b-row class="mx-0"><span class="text-muted">{{ question.answer }}</span></b-row>
          </li>
        </ul>
      </div>
      <div v-if="getMyInfo.hasRoles" class="spnod-admin__account--section">
        <h5 class="spnod-admin__account--header">Surveys</h5>
        <ul v-if="questions">
          <li class="spnod-admin__form--list pb-2" v-for="question in questions">
            <b-row class="mx-0">{{ question.question }}</b-row>
            <b-row class="mx-0"><span class="text-muted">{{ question.answer }}</span></b-row>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'MessageDetails',
  computed: {
    ...mapGetters(['getMessages', 'activeThread', 'getClientInfo', 'getClientId', 'getMyInfo', 'getMessageParticipants', 'biometricsSchema']),
    message: function() {
      if (this.$route.query.threadId) return this.getMessages.find(m => m.threadId === this.activeThread)
    },
    participants: function() {
      if (this.message && this.message.client) {
        let result = this.message.participants.filter(p => p._id !== this.message.client._id)
        if (this.message.client.nutritionist) result = result.filter(p => p._id !== this.message.client.nutritionist._id)
        return result
      }
    },
    biometrics() {
      return this.biometricsSchema.map(s => {
        const answer = this.getClientInfo.biometrics ? this.getClientInfo.biometrics[s.name] : 'N/A'
        return { question: s.placeholder, answer }
      })
    },
    questions: function() {
      if (this.getClientInfo && this.getClientInfo.surveys && this.getClientInfo.surveys[0] && this.getClientInfo.surveys[0].questionsGroups[0].questions.some(q => q.answer)) {
        return this.getClientInfo.surveys[0].questionsGroups[0].questions
      }
    },
    clientAvatar() {
      if (!this.message.client) return
      const participant = this.getMessageParticipants.find(p => p._id === this.message.client._id)
      if (participant && participant.profilePic) return participant.profilePic
    },
    nutritionistAvatar() {
      if (!this.message.client || !this.message.client.nutritionist) return
      const participant = this.getMessageParticipants.find(p => p._id === this.message.client.nutritionist._id)
      if (participant && participant.profilePic) return participant.profilePic
    }
  },
  methods: {
    ...mapActions(['setClientId', 'getClient', 'loadBiometrics']),
    redirectToUserAccount: async function (e) {
      if (this.message.client._id === this.getMyInfo._id) {
        this.$router.push('/account')
      } else {
        await this.setClientId(this.message.client._id)
        this.$router.push('/user/account')
      }
    }
  },
  mounted: async function() {
    if (!this.biometricsSchema.length) await this.loadBiometrics()
  },
  watch: {
    '$route.params': async function () {
      if (this.message && this.message.client && this.message.client._id !== this.getMyInfo._id) {
        await this.setClientId(this.message.client._id)
        await this.getClient()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/Messaging/MessageDetails.vue?d0bbd3d6